// removed by extract-text-webpack-plugin
module.exports = {"icon":"DbPOvTCNNu1Q4fhktoOH6"};


//////////////////
// WEBPACK FOOTER
// ./src/SPRINTA/Topbar/molecules/InputIcon/style.css
// module id = 234
// module chunks = 101